import { render, staticRenderFns } from "./FinancesPartnersModal.vue?vue&type=template&id=a6820078&"
import script from "./FinancesPartnersModal.vue?vue&type=script&lang=js&"
export * from "./FinancesPartnersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports